import Modal from '@material-ui/core/Modal';
import PropTypes from 'prop-types';
import React from 'react';
import './StrModal.css';

const StrModal = ({ children, hideModal, modalClasses, open, title }) => (
  <Modal open={open} onClose={hideModal}>
    <div className="modal-dialog modal-lg">
      <div className={`modal-content ${modalClasses}`}>
        <div className="p3 pl5 pr5">
          <div className="close pull-right">
            <button className="ss-delete mt1" onClick={hideModal} />
          </div>
          <h3>{title}</h3>
          {children}
        </div>
      </div>
    </div>
  </Modal>
);

StrModal.propTypes = {
  children: PropTypes.node.isRequired,
  hideModal: PropTypes.func.isRequired,
  modalClasses: PropTypes.string,
  open: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired
};

StrModal.defaultProps = {
  modalClasses: ''
};

export default StrModal;
